<template>
  <div class="filter-group card form">
    <div class="form-group">
      <label>{{title}}</label>
      <div class="content">
        <div class="from">
          <input-select
            style="margin-bottom: 0px"
            ref="group_id"
            name="group_id"
            :options="groups"
            :allowEmpty="true"
            :preselectFirst="false"
            :onChange="onInputChange"
            :searchable="true"
            placeholder="Select a group"
            :selectedValue="value"
          />
        </div>
        <span class="clear-search" v-if="value" @click="onInputChange(null)">
          <i class="fas fa-times"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import InputSelect from "../form-components/input-select";

export default {
  props: {
    groups: Array,
    value: [Number, String],
    onChange: Function,
    title: String,
  },

    methods: {
    onInputChange: function(value) {
      this.onChange(value);
    },
  },

  components: {
    InputSelect
  }
};
</script>

<style lang="scss" scoped>
  .filter-group {
    z-index: 3;
    position: relative;
    flex: 0 1 0%;
    font-size: 12px;

    .content {
      display: flex;
      align-items: center;
    }

    label {
      padding: 0px 8px;
    }

    .clear-search {
      font-size: 13px;
      cursor: pointer;
      padding: 6px 10px;
      flex: 0 0 120px;

      .fas {
        margin-right: 4px;
      }
    }
  }
</style>